import {tagMetadataKeys} from '../export/tagMetadataKeys.js'
import {contactsExportType} from '../const/contactsExportType.js'
import type {ContactsIteratorResult, ExportMetadataItem, IBroker} from './types.js'

export class PublicIdentifierListContactsIterator {
	// @ts-ignore
	readonly #broker: IBroker
	#currentIndex: number
	readonly #publicIdentifiers: string[]

	constructor(broker: IBroker, publicIdentifiers: string[]) {
		this.#broker = broker
		this.#publicIdentifiers = publicIdentifiers
		this.#currentIndex = -1
	}

	async getNext(_metadata?: object): Promise<ContactsIteratorResult> {
		let result: ContactsIteratorResult | null
		do {
			result = await this.#getNext()
		} while (!result?.found.length && this.canMove())
		return result ?? {found: [], processed: 0}
	}

	canMove(): boolean {
		return this.#currentIndex < this.#publicIdentifiers.length - 1
	}

	getTotal(): number {
		return this.#publicIdentifiers.length
	}

	getMetadata(): ExportMetadataItem[] {
		let result = [
			{
				key: tagMetadataKeys.ExportStartedKey,
				value: tagMetadataKeys.TrueValue
			}
		]
		return result
	}

	getType(): string {
		return contactsExportType.contactsPublicIdentifierList
	}

	async #getNext(): Promise<ContactsIteratorResult> {
		const result: ContactsIteratorResult = {
			found: [],
			processed: 0
		}
		for (this.#currentIndex++; this.#currentIndex < this.#publicIdentifiers.length; this.#currentIndex++) {
			const publicIdentifier = this.#publicIdentifiers[this.#currentIndex]
			let miniContact = {
				miniProfile: {
					publicIdentifier: publicIdentifier,
					fullName: publicIdentifier
				}
			}
			result.found.push(miniContact);

			result.processed++
			if (result.processed >= 50) {
				break;
			}
		}

		return result
	}
}
